module.exports = __webpack_public_path__ + "static/media/United Arab Emirates.e8aa7910.png";